import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import "./print.css";
import Time from "react-time-format";
import NumberFormat from "react-number-format";

class FormPrintRaportyRozhana extends React.Component {
  render() {
    return (
      <>
        <ProductConsumer>
          {(value) => {
            const { d_dataRozhana, JK_kompanyakan, JK_paradan } = value;

            const wakil = d_dataRozhana.map((user, i) => {
              return (
                <tr key={i} className=" f4 fk">
                  {JK_kompanyakan || JK_paradan ? (
                    <>
                      {" "}
                      <td className="fk">{user.zh_wakil}</td>
                      <td className="fk">{user.note}</td>
                      <td className="fk">{user.nawewargr}</td>
                      {JK_kompanyakan == true ? (
                        <>
                          <td>
                            <NumberFormat
                              value={user.nrxe_RRR}
                              thousandSeparator={true}
                              displayType="text"
                            />
                          </td>
                          <td>
                            <NumberFormat
                              value={user.Krini_RRR}
                              thousandSeparator={true}
                              displayType="text"
                            />
                          </td>
                        </>
                      ) : null}
                      <td className={`fk`}>{user.joripara}</td>
                      <td className="fk">
                        <NumberFormat
                          value={
                            Number.isInteger(Number(user.koywasl))
                              ? Number(user.koywasl)
                              : Number(user.koywasl).toFixed(2)
                          }
                          thousandSeparator={true}
                          displayType="text"
                        />
                      </td>
                      <td className="fk ">{user.wasl}</td>
                      <td className="fk">{user.jwlla}</td>
                      <td className="fk">
                        <Time
                          value={user.barwar}
                          format="YYYY-MM-DD"
                          style={{ color: "black" }}
                        />
                      </td>
                      <td className="fk">{user.code}</td>
                    </>
                  ) : (
                    <>
                      {" "}
                      <td className={` fk`}>{user.zh_wakil}</td>
                      <td className="fk">{user.nawi_wakil}</td>
                      <td className="fk ">
                        <NumberFormat
                          value={user.paraymawa}
                          thousandSeparator={true}
                          displayType="text"
                        />
                      </td>
                      <td className="fk ">
                        <NumberFormat
                          value={user.paraydraw}
                          thousandSeparator={true}
                          displayType="text"
                        />
                      </td>
                      <td className="fk">
                        <NumberFormat
                          value={user.kmkrdnawa}
                          thousandSeparator={true}
                          displayType="text"
                        />
                      </td>
                      <td className={`fk `}>{user.joripara}</td>
                      <td className="fk">
                        <NumberFormat
                          value={
                            Number.isInteger(Number(user.koywasl))
                              ? Number(user.koywasl)
                              : Number(user.koywasl).toFixed(2)
                          }
                          thousandSeparator={true}
                          displayType="text"
                        />
                      </td>
                      <td className="fk">{user.jwlla}</td>
                      <td>
                        <Time
                          value={user.barwar}
                          format="YYYY-MM-DD"
                          style={{ color: "black" }}
                        />
                      </td>
                      <td className="fk">{user.code}</td>
                    </>
                  )}
                </tr>
              );
            });

            return (
              <table id="example" className="table table-striped  text-right ">
                <thead>
                  <tr className=" f4">
                    {JK_kompanyakan || JK_paradan ? (
                      <>
                        {" "}
                        <th>کۆد</th>
                        <th>تێبینی</th>
                        <th>ناوی وەرگر</th>
                        {JK_kompanyakan ? (
                          <>
                            <th>RR نرخی</th>
                            <th>RRR کرینی</th>
                          </>
                        ) : null}
                        <th>دراو</th>
                        <th>کۆی پسوولە</th>
                        <th>و.کۆمپانیا</th>
                        <th>جوولە</th>
                        <th>بەروار</th>
                        <th>ژمارە</th>
                      </>
                    ) : (
                      <>
                        {" "}
                        <th>وکیل</th>
                        <th>ناوی وەکیل</th>
                        <th>پارەی ماوە </th>
                        <th>پارەی دراو</th>
                        <th>داشکان</th>
                        <th>دراو</th>
                        <th>کۆی پسوولە</th>
                        <th>جوولە</th>
                        <th>بەروار</th>
                        <th>پسولە</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>{wakil}</tbody>
              </table>
            );
          }}
        </ProductConsumer>
      </>
    );
  }
}
export default FormPrintRaportyRozhana;
